/* eslint-disable react/jsx-key */
import React from 'react'
import { numCol } from '@integec/grid-tools/lib/cols'
import { getUtilityNameMap, getUnitNameMap } from 'core/selectors'
import { utilityReqHeader, unitIdHeader } from 'core/HeaderColTypeProps'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import { getOperatingData, saveOperatingData } from 'api/pgads.js'
import CommonScreen from './CommonScreen'

const headers = [
  utilityReqHeader,
  unitIdHeader,
  numCol({
    ident: 'licThermalPower',
    display: 'LIC Thermal Power',
    width: 200,
  }),
  numCol({
    ident: 'namePlateRating',
    display: 'Name Plate Rating',
    width: 200,
  }),
]

const retrieveTask = apiTargetInfo => getOperatingData(apiTargetInfo)

const modifyTask = apiTargetInfo => data =>
  saveOperatingData(apiTargetInfo)(data)

const title = 'Name Plate Data'

const OperatingData = props => {
  const { utilityNameMap, unitNameMap } = props
  const headerWithFormatter = headers.map(h =>
    h.ident === 'utility'
      ? {
          ...h,
          // ...toSelectionColProps(utilityNameMap),
          dataFormatter: ({ value }) => utilityNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            utilityNameMap[rowData.utility] || rowData.utility,
        }
      : h.ident === 'unitId'
      ? {
          ...h,
          choices: [],
          // dataGetter: generateDataGetter,
          dataFormatter: ({ value }) => unitNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            unitNameMap[rowData.unit] || rowData.unit,
        }
      : h
  )

  // not insert and delete , only Update
  return (
    <CommonScreen
      title={title}
      header={headerWithFormatter}
      saveTask={modifyTask}
      retrieveTask={retrieveTask}
      deleteTask={_ => _}
      altBy={d => d.unitId}
      autoRetrieve
      sortOptions={[
        // { ident: 'utility', display: 'Utility', sortOrder: 'asc' },
        { ident: 'unitId', display: 'Unit', sortOrder: 'asc' },
      ]}
      initialSortOptions={[
        // { ident: 'utility', display: 'Utility', sortOrder: 'asc' },
        { ident: 'unitId', display: 'Unit', sortOrder: 'asc' },
      ]}
      insertComp={false}
      insertCompHeight={0}
      onInsertEvent={_ => _}
      allowInsert={false}
      withDelete={false}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
})

export default connect(mapStateToProps)(OperatingData)
